export default __webpack_public_path__ + "static/media/DarkBlue0001.f50b7946.png";